// extracted by mini-css-extract-plugin
module.exports = {"payment":"Checkout_payment__ogN0x","paymentBorder":"Checkout_paymentBorder__UNlsv","paymentOptions":"Checkout_paymentOptions__E14nT"};